import React from 'react';
import { SimpleSelectField } from '../SimpleSelectField';
import { JobPostingDetailsForm } from '..';
import { SelectOption } from '../../../../../../components/Select';

interface PropTypes {
  form: JobPostingDetailsForm;
  isClearable?: boolean;
  mandatory?: boolean;
  disabled?: boolean;
  organicPost?: boolean;
  onInputChange: (name: string, value: unknown) => void;
}

function salaryOptions(organicPost?: boolean): SelectOption[] {
  const options = [
    { label: 'Yearly', value: 'yearly' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Hourly', value: 'hourly' },
  ];

  if (organicPost) {
    options.push({ label: 'Daily', value: 'daily' });
  }

  return options;
}

export function SalaryPeriod(props: PropTypes) {
  return (
    <SimpleSelectField
      label='Salary Period'
      options={salaryOptions(props.organicPost)}
      value={props.form.salaryPeriod}
      name='salaryPeriod'
      onInputChange={props.onInputChange}
      isClearable={props.isClearable}
      mandatory={props.mandatory}
      placeholder={'Select Range'}
      disabled={props.disabled}
    />
  );
}
